import { render, staticRenderFns } from "./WhatsappLink.vue?vue&type=template&id=68fc2726&scoped=true&"
import script from "./WhatsappLink.vue?vue&type=script&lang=js&"
export * from "./WhatsappLink.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappLink.vue?vue&type=style&index=0&id=68fc2726&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fc2726",
  null
  
)

export default component.exports